import css from './GSMultipleItemsModal.module.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ObjectGroupBy } from 'object-group-bye'

import DataTestId from 'meta/dataTestId'
import { ISelectableGoodServiceTicket } from 'meta/pages/goodsandservices'

import { ButtonRed, ButtonWhiteBlack } from 'components/Actions/Action'
import Img from 'components/Media/Img'

import ItemSelector from './ItemSelector'

interface Props {
  onClose(): void
  onConfirm(): void
  activeCardData: ISelectableGoodServiceTicket
  ticketsData: ISelectableGoodServiceTicket[]
  handleSelectedTicketData(data: ISelectableGoodServiceTicket, remove?: boolean): void
  selectedTicketIds: number[]
}

const GSMultipleItemsModal: React.FC<Props> = (props) => {
  const { onClose, onConfirm, ticketsData, activeCardData, handleSelectedTicketData, selectedTicketIds } = props

  const { t } = useTranslation()

  const [ticketsGroupedByNotes, setTicketsGroupedByNotes] = useState<Array<ISelectableGoodServiceTicket[]>>([])

  useEffect(() => {
    if (ticketsData) {
      setTicketsGroupedByNotes(
        Object.values(
          ObjectGroupBy(ticketsData, (elem) => {
            return elem.data?.notes
          })
        ).filter((x) => x !== undefined)
      )
    }
  }, [ticketsData])

  return (
    <div className={css.outer_wrapper}>
      <div data-testid={DataTestId.bag.multipleSelection} className={css.wrapper}>
        <div className={css.header}>
          <div className={css.title}>{t('goodsAndServices:multipleItems')}</div>
          <div className={css.close} onClick={onClose}>
            <Img src="/icons/close_icon_white_smallcross.svg" />
          </div>
        </div>

        <div className={css.list}>
          {ticketsGroupedByNotes.map((tickets, key) => {
            return (
              <div key={key} className={css.item}>
                <ItemSelector
                  activeCardData={activeCardData}
                  ticketsData={tickets.sort((a, b) => b.idx - a.idx)}
                  handleSelectedTicketData={handleSelectedTicketData}
                />
              </div>
            )
          })}
        </div>

        <div className={css.actions}>
          <ButtonWhiteBlack
            data-testid={DataTestId.bag.btnMultipleSelectionUndo}
            className={css.undo}
            onClick={onClose}
          >
            {t('goodsAndServices:multiple_undo')}
          </ButtonWhiteBlack>
          <ButtonRed
            data-testid={DataTestId.bag.btnMultipleSelectionConfirm}
            disabled={selectedTicketIds.length === 0}
            className={css.confirm}
            onClick={onConfirm}
          >
            {t('goodsAndServices:multiple_confirm', { count: selectedTicketIds.length })}
          </ButtonRed>
        </div>
      </div>
    </div>
  )
}

export default GSMultipleItemsModal
